// Centralized image library — Northern Spain regional photography (Unsplash).
// Used across pages to keep imagery consistent.

export const IMG = {
  // Hero / Mountains
  heroMountain:
    "https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?auto=format&fit=crop&w=2400&q=80", // dramatic mountains
  picosDeEuropa:
    "https://images.unsplash.com/photo-1486870591958-9b9d0d1dda99?auto=format&fit=crop&w=2000&q=80", // green mountain valley
  greenValley:
    "https://images.unsplash.com/photo-1500534314209-a25ddb2bd429?auto=format&fit=crop&w=2000&q=80",
  mistyMountains:
    "https://images.unsplash.com/photo-1502082553048-f009c37129b9?auto=format&fit=crop&w=2000&q=80",

  // Coast / Basque
  cantabrianCoast:
    "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=2000&q=80",
  cliffCoast:
    "https://images.unsplash.com/photo-1505228395891-9a51e7e86bf6?auto=format&fit=crop&w=2000&q=80",
  gaztelugatxe:
    "https://images.unsplash.com/photo-1602343168117-bb8ffe3e2e9f?auto=format&fit=crop&w=2000&q=80",

  // Stone village / culture
  stoneVillage:
    "https://images.unsplash.com/photo-1543248939-ff40856f65d4?auto=format&fit=crop&w=2000&q=80",
  pintxos:
    "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?auto=format&fit=crop&w=2000&q=80",
  market:
    "https://images.unsplash.com/photo-1488459716781-31db52582fe9?auto=format&fit=crop&w=2000&q=80",

  // Interiors — warm modern
  interior1:
    "https://images.unsplash.com/photo-1505691938895-1758d7feb511?auto=format&fit=crop&w=2000&q=80", // warm living room
  interior2:
    "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?auto=format&fit=crop&w=2000&q=80", // modern kitchen
  interior3:
    "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?auto=format&fit=crop&w=2000&q=80", // bedroom
  terrace:
    "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?auto=format&fit=crop&w=2000&q=80", // wooden modern home
  apartmentExterior:
    "https://images.unsplash.com/photo-1518780664697-55e3ad937233?auto=format&fit=crop&w=2000&q=80", // modern house in nature

  // Founder portrait placeholder
  founderBg:
    "https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?auto=format&fit=crop&w=2000&q=80", // dawn mountain
};

export const BRANDS = [
  {
    id: "zynthoro",
    name: "Zynthoro",
    tagline: "The Next-Gen AI ERP Ecosystem",
    short:
      "All-in-one AI business platform for ambitious SMEs. From €499/month.",
    description:
      "Zynthoro is an all-in-one AI business platform for ambitious SMEs. Replace 15+ tools with one connected workspace — finance, HR, marketing, operations, content and more. Powered by Gemini and Claude AI. Three specialist AI assistants — Zyntha, Thoro and Zyona — are available 24/7 to guide you through every task. Starting from €499/month.",
    status: "Live · June 30, 2026",
    statusType: "live",
    url: "https://zynthoro.ai",
    cta: "Visit Zynthoro",
    pricing: "from €499/month",
    powered: ["Anthropic Claude", "Google Gemini"],
    icon: "fa-cube",
    logo: "/assets/logo_zynthoro.png",
    logoBg: "#000000",
  },
  {
    id: "gojidiva",
    name: "GojiDiva",
    tagline: "Premium LGBTQ+ Dating",
    short:
      "A verified-only sanctuary for authentic connection. No bots. No noise.",
    description:
      "GojiDiva is a verified-only premium dating platform designed with intention for the LGBTQ+ community. A safe, curated sanctuary for authentic connection — romance, friendship and chosen family. No bots. No noise. Just real people connecting in a space built for them. Available in three membership tiers: CHIC · ICON · DIVINE.",
    status: "Coming Soon",
    statusType: "soon",
    url: "https://gojidiva.com",
    cta: "Visit GojiDiva",
    contact: "mother@gojidiva.com",
    tiers: ["CHIC", "ICON", "DIVINE"],
    icon: "fa-heart",
    logo: null, // text placeholder per brand guideline
    logoBg: "#C2185B",
  },
  {
    id: "myrootzz",
    name: "My Rootzz",
    tagline: "Your Digital Legacy Vault",
    short:
      "AI-guided memory journaling and human-verified legacy delivery. From €1.49.",
    description:
      "My Rootzz is an AI-guided memory journaling platform that helps you preserve your stories, memories and final messages for the people you love. Human-verified legacy delivery ensures your words reach the right hands at the right time. Available in 5 languages. Starting from €1.49.",
    status: "Live Now",
    statusType: "live",
    url: "https://myrootzz.com",
    cta: "Visit My Rootzz",
    pricing: "€1.49 trial · €54.50/year · €69.50/year · €495 lifetime",
    icon: "fa-tree",
    logo: "/assets/logo_myrootzz.jpg",
    logoBg: "#000000",
  },
];

export const COMPANY = {
  name: "Casa Haya International BV",
  parent: "Casa De La Haya Real Estate Holding BV",
  email: "info@casahaya.com",
  address: "Geurdeland 17G, 6643 DR Andelst, Nederland",
  kvk: "99196581",
  btw: "NL005298485B72",
  founder: "Ramona",
};
